import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import "./FlightList.css";
// import { FaFilter } from "react-icons/fa";
import {
  MdAccessTimeFilled,
  MdOutlineSort,
  MdOutlineAccessTimeFilled,
} from "react-icons/md";
import { MdAirlines } from "react-icons/md";
import { MdSort } from "react-icons/md";
import { MdToggleOff, MdToggleOn } from "react-icons/md";
import { TbFilterFilled } from "react-icons/tb";
import { SiChinasouthernairlines } from "react-icons/si";
import { BsToggleOff, BsToggleOn } from "react-icons/bs";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import { FlightListInfo, formatTime } from "./FlightListInfo";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { flightSearch } from "../../../redux/services/operations/flight";
import { useSelector, useDispatch } from "react-redux";
import FlightListSkeleton from "./FlightListSkeleton";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import "rc-slider/assets/index.css";
// import { cities2 } from "../BookingSearch/Cities";
import { cities12 } from "../../../Cities";
import FlightListCard from "./FlightListCard";
import FilterBar from "./FilterBar";
import ReSearchForm from "./ReSearchForm";
import axios from "axios";
import Filter from "./Filter/Filter";
import Sort from "./Filter/Sort";
import Time from "./Filter/Time";
import Airlines from "./Filter/Airlines";
import { toast } from "react-toastify";

const flightClassDefaultValue = (flightCabinClass) => {
  switch (parseInt(flightCabinClass)) {
    case 2:
      return "2"; // Economy
    case 3:
      return "3"; // PremiumEconomy
    case 4:
      return "4"; // Business
    case 6:
      return "6"; // First
    default:
      return ""; // Default to no selection
  }
};

// Initial slider items (will be updated dynamically)
const initialSliderItems = [
  { date: "Oct 03", price: "7845" },
  { date: "Oct 04", price: "5954" },
  { date: "Oct 05", price: "4155" },
  { date: "Oct 06", price: "5953" },
  { date: "Oct 07", price: "5495" },
  { date: "Oct 08", price: "5953" },
  { date: "Oct 09", price: "4155" },
];

const CalenderSliderContent = styled.div`
  border: 1px solid rgb(228, 228, 228);
  border-right: none;
  border-block: none;
  text-align: center;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FlightList = () => {
  const [fromCurrency, setFromCurrency] = useState("INR");
  const [toCurrency, setToCurrency] = useState("USD");
  const [convertedAmount, setConvertedAmount] = useState(null);
  const [exchangeRate, setExchangeRate] = useState(null);

  const handleChnageCurrency = (amount) => {
    if (amount === undefined || amount === null || amount === "undefined") return "";
    if (!isNaN(amount)) {
      if (exchangeRate) {
        // const convertedValue = amount * exchangeRate;
        // return convertedValue.toFixed(2);
        return amount;
      }
      return amount;
    }
    return amount;
  };
  const token = localStorage.getItem("token");
  const sessionId = localStorage.getItem("sessionId");
  const navigate = useNavigate();
  const { data: routeParams } = useParams();
  const dispatch = useDispatch();
  const search = useSelector((state) => state.flight.search);
  const [sliderValue, setSliderValue] = useState([0, 0]);
  const [isLoading, setIsLoading] = useState(false);
  const [dataSearch, setDataSearch] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const [rooms, setRooms] = useState([{ adults: 1, children: 0, infants: 0 }]);
  const [labelClicked, setLabelClicked] = useState(false);
  const [active, setActive] = useState(true);
  const [active2, setActive2] = useState(false);
  const [active3, setActive3] = useState(false);
  const [numberOfMonths, setNumberOfMonths] = useState(2);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [baggageFilters, setBaggageFilters] = useState([]);
  const [focusedInput, setFocusedInput] = useState(null);
  const [calVisible, setCalVisible] = useState(false);
  const [clickDestination, SetClickDestination] = useState(false);
  const [clickDestination2, SetClickDestination2] = useState(false);
  const [destinationCity, setDestinationCity] = useState("");
  const [selectedCityCode, setSelectedCityCode] = useState("");
  const [destinationCity2, setDestinationCity2] = useState("");
  const [selectedCityCode2, setSelectedCityCode2] = useState("");
  const [travellerActive, setTravellerActive] = useState(false);
  const [showModal, setShowModal] = useState(null);
  const [Visible, setVisible] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [tripsActive, setTripsActive] = useState(false);
  const [checkedStops, setCheckedStops] = useState([
    "non-stop",
    "1-stop",
    "2-stop",
  ]);
  const [deptimeRange, setdepTimeRange] = useState([0, 0]);
  const [arrtimeRange, setarrTimeRange] = useState([0, 0]);
  const [filteredData, setFilteredData] = useState(
    search && search.length > 0 ? search[0] : []
  );
  const traceId = String(sessionStorage.getItem("traceId"));
  const [airlines, setAirlines] = useState([]);
  const [minFare, setMinFare] = useState(0);
  const [maxFare, setMaxFare] = useState(0);
  const [selectedOption, setSelectedOption] = useState();
  const [isNonStop, setIsNonStop] = useState(false);

  const handleOptionChange = (val) => {
    setSelectedOption(val);
  };




  useEffect(() => {
    const searchData = parseSearchParams(routeParams);
    setDataSearch(searchData);

    updateRoomsData(searchData);
    updateDates(searchData);
    if (parseInt(searchData.JourneyType) === 1) handleSearchFlight();
    else if (parseInt(searchData.JourneyType) === 2) handleSearchFlightRound();
    else if (parseInt(searchData.JourneyType) === 3)
      handleSearchFlightMultiPle();
    setSearchInput(searchData.Segments[0].Origin);
    setSearchInput2(searchData.Segments[0].Destination);
    setSelectedOption(parseInt(searchData.Segments[0].FlightCabinClass));

    const destCity = cities12.find(
      (city) => city.AIRPORTCODE === searchData.Segments[0].Origin
    );
    const destCity2 = cities12.find(
      (city) => city.AIRPORTCODE === searchData.Segments[0].Destination
    );
    setDestination1(destCity);
    setDestination2(destCity2);
  }, [routeParams]);

  useEffect(() => {
    if (dataSearch) {
      setIsLoading(true);
      const updatedSearchData = { ...dataSearch };
      updatedSearchData.TokenId = token;
      updatedSearchData.EndUserIp = "192.168.10.10";

      // dispatch(flightSearch(updatedSearchData, navigate));

      const searchdatamulticurl = {
        origin: updatedSearchData.Segments[0].Origin,
        destination: updatedSearchData.Segments[0].Destination,
        departureDate: updatedSearchData.Segments[0].PreferredDepartureTime,
        adult: parseInt(updatedSearchData.AdultCount),
        child: parseInt(updatedSearchData.ChildCount),
        infant: parseInt(updatedSearchData.InfantCount),
        type: parseInt(updatedSearchData.JourneyType),
        cabin: parseInt(updatedSearchData.Segments[0].FlightCabinClass),
        tboToken: token,
        partocrsSession: sessionId,
        preferredAirline: updatedSearchData.PreferredAirline || "",
        DirectFlight: updatedSearchData.DirectFlight || false,
        ResultFareType: updatedSearchData.ResultFareType || 2,
      };

      console.log("search data multicurl", searchdatamulticurl);
      dispatch(flightSearch(searchdatamulticurl, true, false, navigate))
        .then(() => {
          setIsLoading(false);
        })
        .catch((error) => {
          // console.error("Error:", error);
          setIsLoading(false);
        });
    }
  }, [dataSearch, dispatch, navigate, token]);
  console.log("Updated Search Data", dataSearch);
  useEffect(() => {
    const handleResize = () => {
      setBreakpoints();
    };
    window.addEventListener("resize", handleResize);
    setBreakpoints();
    return () => window.removeEventListener("resize", handleResize);
  });

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (search && search.length > 0) {
      setFilteredData(search[0]);
    }
  }, [search]);
  const [airlineCodes, setAirlineCodes] = useState([]);
  useEffect(() => {
    if (search && search[0]) {
      // const airlineNames = search[0]
      //   .map((flight) => ({
      //     name: flight.Segments[0][0].Airline.AirlineName,
      //     selected: false,
      //   }))
      //   .filter((airline) => airline.name);
      // const uniqueAirlines = Array.from(
      //   new Set(airlineNames.map((airline) => airline.name))
      // );
      // const uniqueAirlinesWithSelected = uniqueAirlines.map((airlineName) => ({
      //   name: airlineName,
      //   selected: false,
      // }));
      // setAirlines(uniqueAirlinesWithSelected);
      // console.log("airlines", uniqueAirlines);

      // Extract airline name and code from the flight data
      const airlineData = search[0]
        .map((flight) => ({
          name: flight.Segments[0][0].Airline.AirlineName,
          code: flight.Segments[0][0].Airline.AirlineCode, // Extract AirlineCode
        }))
        .filter((airline) => airline.name);

      // Get unique airline names
      const uniqueAirlines = Array.from(
        new Set(airlineData.map((airline) => airline.name))
      );

      // Create airline objects with unique names and their respective codes
      const uniqueAirlinesWithSelected = uniqueAirlines.map((airlineName) => {
        const airline = airlineData.find(
          (airline) => airline.name === airlineName
        );
        return {
          name: airline.name,
          code: airline.code, // Include AirlineCode
        };
      });

      // Separate the names and codes into two arrays
      const airlineNames = uniqueAirlinesWithSelected.map((airline) => ({
        name: airline.name, // Set name
        selected: false, // Set selected flag to false
      }));

      const airlineCodes = uniqueAirlinesWithSelected.map(
        (airline) => airline.code
      );

      // Update both states: one for names, one for codes
      setAirlines(airlineNames); // Set the names state
      setAirlineCodes(airlineCodes); // Set the codes state

      // Log the results
      console.log("Airlines with Names and Selection Status:", airlineNames);
      console.log("Airline Codes:", airlineCodes);

      const baggageOptions = search[0]
        .map((flight) => flight.Segments[0][0].Baggage)
        .filter((baggage) => baggage);
      const baggageMap = new Map();
      baggageOptions.forEach((baggage) => {
        const normalizedBaggage =
          baggage && baggage.toLowerCase().replace(/\s+/g, "");
        if (!baggageMap.has(normalizedBaggage)) {
          baggageMap.set(normalizedBaggage, baggage); // Store the original baggage
        }
      });

      // Extract unique baggage values and store them for filters
      const uniqueBaggageWithSelected = Array.from(baggageMap.values()).map(
        (baggageValue) => ({
          value: baggageValue,
          selected: false,
        })
      );
      setBaggageFilters(uniqueBaggageWithSelected);

      console.log("Baggage options", uniqueBaggageWithSelected);
    }
  }, [search]);

  useEffect(() => {
    if (search && search.length > 0) {
      const fares = search[0].map((flight) => flight.Fare.PublishedFare);

      const minFare = Math.min(...fares);
      const maxFare = Math.max(...fares);
      setMinFare(minFare);
      setMaxFare(maxFare);

      setSliderValue([minFare, maxFare]);
    }
  }, [search]);

  // useEffect(() => {
  //   applyFilters();
  // }, [search, sliderValue, deptimeRange, arrtimeRange, airlines, checkedStops]);

  const parseSearchParams = (data) => {
    const searchData = {
      Segments: [{}],
    };
    const params = decodeURIComponent(data).split("*");

    params.forEach((param) => {
      const [key, value] = param.split("_");
      switch (key) {
        case "dest":
          searchData.Segments[0].Destination = value;
          break;
        case "org":
          searchData.Segments[0].Origin = value;
          break;
        case "dep":
          searchData.Segments[0].PreferredDepartureTime = value;
          break;
        case "arr":
          searchData.Segments[0].PreferredArrivalTime = value;
          break;
        case "px":
          const [adultCount, childCount, infantCount] = value.split("-");
          searchData.AdultCount = adultCount;
          searchData.ChildCount = childCount;
          searchData.InfantCount = infantCount;
          break;
        case "jt":
          searchData.JourneyType = value;
          break;
        case "cbn":
          searchData.Segments[0].FlightCabinClass = value;
          break;
        case "pi":
          searchData.PreferredAirline = value;
          break;
        case "rft":
          searchData.ResultFareType = value;
          break;
        case "df":
          searchData.DirectFlight = value;
          break;
        default:
          break;
      }
    });

    return searchData;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const tripTypeMapping = {
      OneWay: 1,
      RoundTrip: 2,
      MultiCity: 3,
    };

    // const cabin = event.target.cabinClass.value;
    const tripType = tripTypeMapping[!active ? "RoundTrip" : "OneWay"];

    const SearchData = {
      EndUserIp: "192.168.10.10",
      AdultCount: rooms[0].adults,
      ChildCount: rooms[0].children,
      InfantCount: rooms[0].infants,
      JourneyType: tripType,
      Segments: [
        {
          Origin: event.target.from.value,
          Destination: event.target.to.value,
          FlightCabinClass: selectedOption,
          PreferredDepartureTime: startDate.startOf("day").format("YYYY-MM-DD"),
          PreferredArrivalTime: endDate
            ? endDate.startOf("day").format("YYYY-MM-DD")
            : startDate.startOf("day").format("YYYY-MM-DD"),
        },
      ],
    };
    if (active) {
      window.location.assign(
        `/flightList/${encodeURIComponent(
          `dest_${SearchData.Segments[0].Destination}*org_${SearchData.Segments[0].Origin}*dep_${SearchData.Segments[0].PreferredDepartureTime}*arr_${SearchData.Segments[0].PreferredArrivalTime}*px_${SearchData.AdultCount}-${SearchData.ChildCount}-${SearchData.InfantCount}*jt_${SearchData.JourneyType}*cbn_${SearchData.Segments[0].FlightCabinClass}`
        )}`
      );
    }
    if (active2) {
      if (destination1.COUNTRYCODE !== destination2.COUNTRYCODE) {
        window.location.assign(
          `/international-round/${encodeURIComponent(
            `dest_${SearchData.Segments[0].Destination}*org_${SearchData.Segments[0].Origin}*dep_${SearchData.Segments[0].PreferredDepartureTime}*arr_${SearchData.Segments[0].PreferredArrivalTime}*px_${SearchData.AdultCount}-${SearchData.ChildCount}-${SearchData.InfantCount}*jt_${SearchData.JourneyType}*cbn_${SearchData.Segments[0].FlightCabinClass}`
          )}`
        );
      } else {
        window.location.assign(
          `/round/${encodeURIComponent(
            `dest_${SearchData.Segments[0].Destination}*org_${SearchData.Segments[0].Origin}*dep_${SearchData.Segments[0].PreferredDepartureTime}*arr_${SearchData.Segments[0].PreferredArrivalTime}*px_${SearchData.AdultCount}-${SearchData.ChildCount}-${SearchData.InfantCount}*jt_${SearchData.JourneyType}*cbn_${SearchData.Segments[0].FlightCabinClass}`
          )}`
        );
      }
    }
  };

  const handleDateClick = (newDate) => {
    if (!dataSearch || !dataSearch.Segments || !dataSearch.Segments[0]) return;

    const SearchData = { ...dataSearch };
    SearchData.Segments[0].PreferredDepartureTime = newDate;
    
    let path = "/flightList/";
    if (active2) {
      if (destination1 && destination2 && destination1.COUNTRYCODE !== destination2.COUNTRYCODE) {
        path = "/international-round/";
      } else {
        path = "/round/";
      }
    }

    let paramStr = `dest_${SearchData.Segments[0].Destination}*org_${SearchData.Segments[0].Origin}*dep_${SearchData.Segments[0].PreferredDepartureTime}*arr_${SearchData.Segments[0].PreferredArrivalTime || SearchData.Segments[0].PreferredDepartureTime}*px_${SearchData.AdultCount}-${SearchData.ChildCount}-${SearchData.InfantCount}*jt_${SearchData.JourneyType}*cbn_${SearchData.Segments[0].FlightCabinClass}`;
    
    if (SearchData.PreferredAirline) paramStr += `*pi_${SearchData.PreferredAirline}`;
    if (SearchData.ResultFareType) paramStr += `*rft_${SearchData.ResultFareType}`;
    if (SearchData.DirectFlight) paramStr += `*df_${SearchData.DirectFlight}`;

    window.location.assign(`${path}${encodeURIComponent(paramStr)}`);
  };

  const handleSearchFlight = () => {
    setActive(true);
    setActive2(false);
    setActive3(false);
    setEndDate(null);
  };
  const handleSearchFlightRound = () => {
    setActive2(true);
    setActive(false);
    setActive3(false);
  };
  const handleSearchFlightMultiPle = () => {
    setActive3(true);
    setActive(false);
    setActive2(false);
  };

  const setBreakpoints = () => {
    const isSmallScreen = window.innerWidth <= 768;
    const isMediumScreen = window.innerWidth > 768 && window.innerWidth <= 992;

    if (isSmallScreen) {
      setDateRangeConfig(1, 30, 30);
    } else if (isMediumScreen) {
      setDateRangeConfig(1, 40, 60);
    } else {
      setDateRangeConfig(2, 40, 50);
    }
  };

  const setDateRangeConfig = (numberOfMonths, daysize) => {
    setNumberOfMonths(numberOfMonths);
  };

  const isSameDay = (date1, date2) => date1.isSame(date2, "day");

  const renderDayContents = (day) => {
    const key = day.format("YYYY-MM-DD");
    const fare = dayFareMap[key];
    const isStartDate = startDate && isSameDay(day, startDate);
    const isEndDate = endDate && isSameDay(day, endDate);
    const isInRange =
      startDate && endDate && day.isBetween(startDate, endDate, "day", "[]");

    let classNames = ["DayPicker-Day"];
    if (isStartDate) classNames.push("DayPicker-Day--start");
    if (isEndDate) classNames.push("DayPicker-Day--end");
    if (isInRange) classNames.push("DayPicker-Day--range");

    return (
      <div className={classNames.join(" ")}>
        <span style={{ fontWeight: "600", fontSize: "13px" }}>
          {day.format("D")}
        </span>
        <br />
        {fareLoading && day.date() === 10 && (
          <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
            <Spinner animation="border" variant="danger" style={{ width: "10px", height: "10px", borderWidth: "1px" }} />
          </span>
        )}
        {fare && (
          <span
            style={{ fontSize: "10px", color: "#1a4f87"}}
          >
            ₹{fare}
          </span>
        )}
      </div>
    );
  };

  const handleDatesChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
    if (startDate && endDate) {
      setFocusedInput(null);
      setCalVisible(false);
    } else if (startDate) {
      setFocusedInput("endDate");
    }
  };
const [currentVisibleMonth, setCurrentVisibleMonth] = useState(moment());
  const toggleCalendar = (input) => {
    const willOpen = !calVisible;
    setCalVisible(willOpen);
    
    if (willOpen) {
      const base = startDate || moment();
      setCurrentVisibleMonth(base);
      if (loadedMonths.size === 0) fetchMultipleMonthsFares(base); // Fetch if empty, or just duplicate fetch (API cheap call) 
      else fetchMultipleMonthsFares(base); // Just fetch to be safe

      if (input === "startDate") {
        setFocusedInput("startDate");
      } else if (input === "endDate") {
        setFocusedInput("endDate");
      } else {
        // This odd double-toggle logic from original
        setCalVisible(true); // Ensure visible
        setFocusedInput("startDate");
      }
    } else {
        // Closing...
    }
  };

  const updateRoom = (index, field, value) => {
    const updatedRooms = [...rooms];
    updatedRooms[index][field] = value;
    setRooms(updatedRooms);
  };

  const updateRoomsData = (searchData) => {
    const updatedRooms = [
      {
        adults: parseInt(searchData.AdultCount),
        children: parseInt(searchData.ChildCount),
        infants: parseInt(searchData.InfantCount),
      },
    ];
    setRooms(updatedRooms);
  };

  const updateDates = (searchData) => {
    const departureTime = moment(searchData.Segments[0].PreferredDepartureTime);
    const arrivalTime = moment(searchData.Segments[0].PreferredArrivalTime);
    setStartDate(departureTime);
    // active2 &&
    setEndDate(arrivalTime);
  };

  const parseFareRule = (fareRuleDetail) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = fareRuleDetail;
    const listItems = Array.from(tempDiv.querySelectorAll("li")).map((li) =>
      li.textContent.trim()
    );

    return listItems;
  };

  const [fareRules, setFareRules] = useState("");
  const [activeFlightId, setActiveFlightId] = useState(null);
  const handleClickPhone = async (id) => {
    setActiveFlightId(activeFlightId === id ? null : id);
  };
  const handleClick = async (id, SrdvIndex) => {
    setActiveId(activeId === id ? null : id);
    console.log("srdvIdx", SrdvIndex);
    if (SrdvIndex !== "SrdvP" && SrdvIndex !== "SrdvTJ") {
      console.log("tbo farerule called");
      const response1 = await axios.post(
        "https://admin.travelsdata.com/api/flight-fare-rule",
        {
          EndUserIp: "192.168.11.58",
          TokenId: token,
          TraceId: traceId,
          ResultIndex: id,
        }
      );
      console.log("response1", response1);
      setFareRules(
        response1.data.data.FareRules[0] &&
          parseFareRule(response1.data.data.FareRules[0].FareRuleDetail)
      );
    } else if (SrdvIndex === "SrdvTJ") {
      console.log("tj farerule called");
      const responseTJ1 = await axios.post(
        "https://admin.travelsdata.com/api/flight_farerule",
        {
          id: id,
          flowType: "SEARCH",
        }
      );
      console.log("response1", responseTJ1);
      if (responseTJ1.data.success)
        setFareRules(
          responseTJ1.data.data.fareRule && responseTJ1.data.data.fareRule
        );
    } else if (SrdvIndex === "SrdvP") {
      console.log("parto farerule called");
      const responseP1 = await axios.post(
        "https://admin.travelsdata.com/api/air_rules",
        {
          SessionId: sessionId,
          FareSourceCode: id,
        }
      );
      console.log("responseP1", responseP1);
      if (responseP1.data.success)
        setFareRules(
          responseP1.data.data.FareRules[0] &&
            responseP1.data.data.FareRules[0].RuleDetails[0].Rules
        );
    }
  };

  const [isItemSelected, setIsItemSelected] = useState(false);
  const [isItemSelected2, setIsItemSelected2] = useState(false);
  const [destination1, setDestination1] = useState("");
  const [destination2, setDestination2] = useState("");

  const handleCitySelect = (city) => {
    setDestinationCity(`${city["CITYNAME"]} (${city["AIRPORTCODE"]})`);
    setSelectedCityCode(city["AIRPORTCODE"]);
    SetClickDestination(false); // Close the city suggestion div
    setSearchInput(`${city["AIRPORTCODE"]}`); // Clear the search input after selecting a city
    setIsItemSelected(true);
    setDestination1(city);
  };

  const handleCitySelect2 = (city) => {
    setDestinationCity2(`${city["CITYNAME"]} (${city["AIRPORTCODE"]})`);
    setSelectedCityCode2(city["AIRPORTCODE"]);
    SetClickDestination2(false); // Close the city suggestion div
    setSearchInput2(`${city["AIRPORTCODE"]}`); // Clear the search input after selecting a city
    setIsItemSelected2(true);
    setDestination2(city);
  };
  //  const traceId = useSelector((state) => state.flight.traceId)
  const [moreFareLoading, setMoreFareLoading] = useState(false);
  const [moreFare, setMoreFare] = useState([]);
  const [selectedFare, setSelectedFare] = useState(moreFare?.[0] || null);

  const handleMoreFare = async (idx) => {
    setShowModal(showModal === idx ? null : idx);
    setActiveFlightId(activeFlightId === idx ? null : idx);
    setMoreFareLoading(true);

    try {
      const response = await axios.post(
        "https://admin.travelsdata.com/api/Upsell",
        {
          TraceId: traceId,
          ResultIndex: idx,
        }
      );
      console.log("response more fare", response.data);
      if (response.data?.success) {
        setMoreFare(response.data.data.Results);
        setSelectedFare(response.data.data.Results[0]);
      } else {
        console.error("API Error:", response.data?.message);
        toast.error("API Error: " + response.data?.message);
      }
    } catch (error) {
      console.error("Request failed:", error);
      toast.error("Failed to fetch upsell data.");
    } finally {
      setMoreFareLoading(false);
    }
  };
  const handlebookmodal = (url, stat) => {
    // navigate(url);

    navigate(`/flight-detail/${url}/null`);
    setShowModal(false);
  };

  const handleScroll = () => {
    const scrollTop = window.pageYOffset;
    setVisible(scrollTop > 150);
  };

  const handleSliderChange = (value) => {
    setSliderValue(value);
  };

  const handleCheckedstops = (stopType) => {
    setCheckedStops([stopType]);

    if (checkedStops.includes(stopType)) {
      setCheckedStops(checkedStops.filter((stop) => stop !== stopType));
    } else {
      setCheckedStops([...checkedStops, stopType]);
    }
  };

  const handledepTimeFilter = (range) => {
    if (deptimeRange[0] === range[0] && deptimeRange[1] === range[1])
      setdepTimeRange([0, 0]);
    else setdepTimeRange(range);
  };

  const handlearrTimeFilter = (range) => {
    if (arrtimeRange[0] === range[0] && arrtimeRange[1] === range[1])
      setarrTimeRange([0, 0]);
    else setarrTimeRange(range);
  };
  const [sortType, setSortType] = useState(null);
  const applyFilters = () => {
    if ((search && search.length === 0) || isLoading) return;

    const selectedAirlines = airlines
      .filter((airline) => airline.selected)
      .map((airline) => airline.name);

    const getTotalDuration = (segments) =>
      segments.reduce((sum, seg) => sum + seg.Duration, 0);

    let newFilteredData =
      search &&
      search[0] &&
      search[0].filter((e) => {
        const fareInRange =
          e.Fare.PublishedFare >= sliderValue[0] &&
          e.Fare.PublishedFare <= sliderValue[1];

        const depTimeInRange =
          (deptimeRange[0] === 0 && deptimeRange[1] === 0) ||
          (new Date(e.Segments[0][0].Origin.DepTime).getHours() >=
            deptimeRange[0] &&
            new Date(e.Segments[0][0].Origin.DepTime).getHours() <=
              deptimeRange[1]);

        const arrTimeInRange =
          (arrtimeRange[0] === 0 && arrtimeRange[1] === 0) ||
          (new Date(e.Segments[0][0].Destination.ArrTime).getHours() >=
            arrtimeRange[0] &&
            new Date(e.Segments[0][0].Destination.ArrTime).getHours() <=
              arrtimeRange[1]);

        const isAirlineSelected =
          selectedAirlines.length === 0 ||
          selectedAirlines.includes(e.Segments[0][0].Airline.AirlineName);

        const stopCount = e.Segments[0].length - 1;
        const stopMatch =
          checkedStops.length === 0 ||
          (checkedStops.includes("non-stop") && stopCount === 0) ||
          (checkedStops.includes("1-stop") && stopCount === 1) ||
          (checkedStops.includes("2-stop") && stopCount >= 2);

        return (
          fareInRange &&
          depTimeInRange &&
          arrTimeInRange &&
          isAirlineSelected &&
          stopMatch
        );
      });

    // SORTING STARTS HERE
    if (sortType === "price") {
      newFilteredData.sort(
        (a, b) => a.Fare.PublishedFare - b.Fare.PublishedFare
      );
    }

    if (sortType === "departure") {
      newFilteredData.sort(
        (a, b) =>
          new Date(a.Segments[0][0].Origin.DepTime) -
          new Date(b.Segments[0][0].Origin.DepTime)
      );
    }

    if (sortType === "fastest") {
      newFilteredData.sort(
        (a, b) =>
          getTotalDuration(a.Segments[0]) - getTotalDuration(b.Segments[0])
      );
    }

    // if (sortType === "smart") {
    //   newFilteredData.sort((a, b) => {
    //     const stopA = a.Segments[0].length - 1;
    //     const stopB = b.Segments[0].length - 1;

    //     const scoreA =
    //       stopA * 1000 +
    //       getTotalDuration(a.Segments[0]) +
    //       a.Fare.PublishedFare / 10;

    //     const scoreB =
    //       stopB * 1000 +
    //       getTotalDuration(b.Segments[0]) +
    //       b.Fare.PublishedFare / 10;

    //     return scoreA - scoreB;
    //   });
    // }

    if (sortType === "smart") {
      newFilteredData.sort((a, b) => {
        const getTotalDuration = (segments) =>
          segments.reduce((sum, seg) => sum + seg.Duration, 0);

        const stopA = a.Segments[0].length - 1;
        const stopB = b.Segments[0].length - 1;

        const durA = getTotalDuration(a.Segments[0]);
        const durB = getTotalDuration(b.Segments[0]);

        const priceA = a.Fare.PublishedFare;
        const priceB = b.Fare.PublishedFare;

        const scoreA = stopA * 5000 + durA * 2 + priceA / 5;
        const scoreB = stopB * 5000 + durB * 2 + priceB / 5;

        return scoreA - scoreB;
      });
    }

    setFilteredData(newFilteredData);
  };

  // IMPORTANT: Add sortType here
  useEffect(() => {
    applyFilters();
  }, [
    search,
    sliderValue,
    deptimeRange,
    arrtimeRange,
    airlines,
    checkedStops,
    sortType,
  ]);

  const handleChecked = (airlineName) => {
    const updatedAirlines = airlines.map((airline) =>
      airline.name === airlineName
        ? { ...airline, selected: !airline.selected }
        : airline
    );
    setAirlines(updatedAirlines);
  };

  const handleShowAllairlinenames = (event) => {
    const isChecked = event.target.checked;
    const updatedAirlines = airlines.map((airline) => ({
      ...airline,
      selected: isChecked,
    }));
    setAirlines(updatedAirlines);
  };

  const handleShowAllStops = (event) => {
    if (event.target.checked) {
      setCheckedStops(["non-stop", "1-stop", "2-stop"]);
    } else {
      setCheckedStops([]);
    }
  };

  const clearAllFilters = () => {
    setSliderValue([minFare, maxFare]);
    setdepTimeRange([0, 0]);
    setarrTimeRange([0, 0]);
    setCheckedStops(["non-stop", "1-stop", "2-stop"]);

    const updatedAirlines = airlines.map((airline) => ({
      ...airline,
      selected: true,
    }));
    setAirlines(updatedAirlines);
  };

  // const [searchInput, setSearchInput] = useState(destinationCity);
  // const [searchInput2, setSearchInput2] = useState(destinationCity2);

  // const handleInputChange = (event) => {
  //   const userInput = event.target.value.toUpperCase();
  //   setSearchInput(userInput);
  //   // const filteredCities = cities2.filter((city) => {
  //   //   return (
  //   //     city["Airport Name"].toLowerCase().includes(userInput) ||
  //   //     city["Airport Code"].toLowerCase().includes(userInput) ||
  //   //     city["City Code"].toLowerCase().includes(userInput) ||
  //   //     city["Country Name"].toLowerCase().includes(userInput) ||
  //   //     city["Country Code"].toLowerCase().includes(userInput)
  //   //   );
  //   // });
  //   // setCities2(filteredCities);
  //   setIsItemSelected(false); // Reset the state when input changes
  // };

  // const handleInputChange2 = (event) => {
  //   const userInput = event.target.value.toUpperCase();
  //   setSearchInput2(userInput);
  //   // const filteredCities = cities2.filter((city) => {
  //   //   return (
  //   //     city["Airport Name"].toLowerCase().includes(userInput) ||
  //   //     city["Airport Code"].toLowerCase().includes(userInput) ||
  //   //     city["City Code"].toLowerCase().includes(userInput) ||
  //   //     city["Country Name"].toLowerCase().includes(userInput) ||
  //   //     city["Country Code"].toLowerCase().includes(userInput)
  //   //   );
  //   // });
  //   // setCities2(filteredCities);
  //   setIsItemSelected2(false); // Reset the state when input changes
  // };

  // const filteredCities = cities2.filter(
  //   (city) =>
  //     city["AIRPORTNAME"].toLowerCase().includes(searchInput.toLowerCase()) ||
  //     city["AIRPORTCODE"].toLowerCase().includes(searchInput.toLowerCase()) ||
  //     city["CITYCODE"].toLowerCase().includes(searchInput.toLowerCase()) ||
  //     city["COUNTRYNAME"].toLowerCase().includes(searchInput.toLowerCase()) ||
  //     city["COUNTRYCODE"].toLowerCase().includes(searchInput.toLowerCase()) ||
  //     city["CITYNAME"].toLowerCase().includes(searchInput.toLowerCase())
  // ).map((city) => {
  //   let priority = 3;

  //   if (city["CITYCODE"].toLowerCase().includes(searchInput.toLowerCase())) {
  //     priority = 1; // Highest priority for city code matches
  //   } else if (city["CITYNAME"].toLowerCase().includes(searchInput.toLowerCase())) {
  //     priority = 2; // Second priority for city name matches
  //   } else if (city["COUNTRYNAME"].toLowerCase().includes(searchInput.toLowerCase())) {
  //     priority = 3; // Third priority for country name matches
  //   }

  //   return { ...city, priority };
  // })
  // .sort((a, b) => a.priority - b.priority);

  // const filteredCities2 = cities2.filter(
  //   (city) =>
  //     city["AIRPORTNAME"].toLowerCase().includes(searchInput2.toLowerCase()) ||
  //     city["AIRPORTCODE"].toLowerCase().includes(searchInput2.toLowerCase()) ||
  //     city["CITYCODE"].toLowerCase().includes(searchInput2.toLowerCase()) ||
  //     city["COUNTRYNAME"].toLowerCase().includes(searchInput2.toLowerCase()) ||
  //     city["COUNTRYCODE"].toLowerCase().includes(searchInput2.toLowerCase()) ||
  //     city["CITYNAME"].toLowerCase().includes(searchInput2.toLowerCase())
  // ).map((city) => {
  //   let priority = 3;

  //   if (city["CITYCODE"].toLowerCase().includes(searchInput2.toLowerCase())) {
  //     priority = 1; // Highest priority for city code matches
  //   } else if (city["CITYNAME"].toLowerCase().includes(searchInput2.toLowerCase())) {
  //     priority = 2; // Second priority for city name matches
  //   } else if (city["COUNTRYNAME"].toLowerCase().includes(searchInput2.toLowerCase())) {
  //     priority = 3; // Third priority for country name matches
  //   }

  //   return { ...city, priority };
  // })
  // .sort((a, b) => a.priority - b.priority);

  const [searchInput, setSearchInput] = useState(destinationCity);
  const [searchInput2, setSearchInput2] = useState(destinationCity2);

  // Calendar Fare Logic
  const [dayFareMap, setDayFareMap] = useState({});
  const [fareLoading, setFareLoading] = useState(false);
  const [loadedMonths, setLoadedMonths] = useState(new Set());
  const [sliderItems, setSliderItems] = useState(initialSliderItems);

  const fetchCalendarFaresForMonth = useCallback(async (targetMonth, customOrigin, customDest, customCabin, customJT) => {
    try {
      const journeyType = customJT || (active ? 1 : active2 ? 2 : 3);
      const cabin = customCabin || selectedOption || 2; 
      
      const origin = customOrigin || searchInput;
      const destination = customDest || searchInput2;

      if (!origin || !destination) return {};
      
      const now = moment();
      let preferredDate;
      if (targetMonth.isSame(now, 'month') && targetMonth.isSame(now, 'year')) {
        preferredDate = now;
      } else {
        preferredDate = targetMonth.clone().startOf("month");
      }
      const preferred = preferredDate.format("YYYY-MM-DD[T]00:00:00");
      
      const payload = {
        JourneyType: String(journeyType),
        PreferredAirlines: null,
        Segments: [{
            Origin: origin,
            Destination: destination,
            FlightCabinClass: String(cabin),
            PreferredDepartureTime: preferred,
        }],
        Sources: null,
      };
      
      const res = await axios.post("https://admin.travelsdata.com/api/flight-calender-fare", payload);
      const json = res && res.data;
      if (json && json.success && json.data && Array.isArray(json.data.SearchResults)) {
        const m = {};
        json.data.SearchResults.forEach((item) => {
          const key = moment(item.DepartureDate).format("YYYY-MM-DD");
          const f = Number(item.Fare);
          if (!isNaN(f)) {
            if (!m[key] || f < m[key]) m[key] = f;
          }
        });
        return m;
      } else {
        return {};
      }
    } catch (e) {
      console.error("Error fetching fares:", e);
      return {};
    }
  }, [active, active2, searchInput, searchInput2, selectedOption]);
  const [cities2, setCities2] = useState([]);
  const [cities22, setCities22] = useState([]);

  useEffect(() => {
    if (dataSearch && dataSearch.Segments && dataSearch.Segments[0]) {
      const depDate = moment(dataSearch.Segments[0].PreferredDepartureTime);
      const items = [];
      for (let i = 0; i < 30; i++) {
        const d = depDate.clone().add(i, "days");
        const dateStr = d.format("YYYY-MM-DD");
        const priceValue = dayFareMap[dateStr] || 0; 
        items.push({
          date: d.format("MMM DD"),
          price: priceValue.toString(),
          fullDate: dateStr
        });
      }
      setSliderItems(items);
    }
  }, [dataSearch, dayFareMap]);

  // Fetch fares for the slider range
  useEffect(() => {
    if (dataSearch && dataSearch.Segments && dataSearch.Segments[0]) {
      const { Origin, Destination, FlightCabinClass } = dataSearch.Segments[0];
      const journeyType = dataSearch.JourneyType;
      const depDate = moment(dataSearch.Segments[0].PreferredDepartureTime);

      const fetchSliderFares = async () => {
        setFareLoading(true);
        const f1 = await fetchCalendarFaresForMonth(depDate, Origin, Destination, FlightCabinClass, journeyType);
        const f2 = await fetchCalendarFaresForMonth(depDate.clone().add(1, 'month'), Origin, Destination, FlightCabinClass, journeyType);
        
        setDayFareMap(prev => ({ ...prev, ...f1, ...f2 }));
        setFareLoading(false);
      };
      fetchSliderFares();
    }
  }, [dataSearch, fetchCalendarFaresForMonth]);

  const fetchMultipleMonthsFares = async (baseMonth) => {
    setFareLoading(true);
    try {
      const monthsToFetch = [baseMonth.clone(), baseMonth.clone().add(1, "month")];
      const results = await Promise.all(monthsToFetch.map(m => fetchCalendarFaresForMonth(m)));
      const mergedFares = {};
      results.forEach(r => Object.assign(mergedFares, r));
      setDayFareMap(prev => ({...prev, ...mergedFares}));
      
      const newLoaded = new Set();
      monthsToFetch.forEach(m => newLoaded.add(m.format("YYYY-MM")));
      setLoadedMonths(prev => {
          const s = new Set(prev);
          newLoaded.forEach(x => s.add(x));
          return s;
      });
    } catch (e) {
      console.error(e);
    } finally {
      setFareLoading(false);
    }
  };

  const handlePrevMonthClick = async (newMonth) => {
    const monthKey = newMonth.format("YYYY-MM");
    if (!loadedMonths.has(monthKey)) {
        setFareLoading(true);
        const fares = await fetchCalendarFaresForMonth(newMonth);
        setDayFareMap(prev => ({...prev, ...fares}));
        setLoadedMonths(prev => new Set([...prev, monthKey]));
        setFareLoading(false);
    }
  };

  const handleNextMonthClick = async (newMonth) => {
    const currentKey = newMonth.format("YYYY-MM");
    const nextKey = newMonth.clone().add(1, "month").format("YYYY-MM");
    const toFetch = [];
    if (!loadedMonths.has(currentKey)) toFetch.push(newMonth);
    if (!loadedMonths.has(nextKey)) toFetch.push(newMonth.clone().add(1, "month"));
    
    if (toFetch.length > 0) {
        setFareLoading(true);
        const results = await Promise.all(toFetch.map(m => fetchCalendarFaresForMonth(m)));
        const merged = {};
        results.forEach(r => Object.assign(merged, r));
        setDayFareMap(prev => ({...prev, ...merged}));
        setLoadedMonths(prev => {
            const newSet = new Set(prev);
            toFetch.forEach(m => newSet.add(m.format("YYYY-MM")));
            return newSet;
        });
        setFareLoading(false);
    }
  };


  const fetchDatas = async (value) => {
    // setIsLoadingFrom(true);

    try {
      const requestData = {
        city: value,
      };

      const response = await axios.post(
        "https://admin.travelsdata.com/api/airport",
        requestData
      );

      const json = response.data;
      console.log("json response", json);

      const results = json.data
        .filter((user) => {
          return (
            user &&
            ((user.CITYNAME &&
              user.CITYNAME.toLowerCase().includes(value.toLowerCase())) ||
              (user.AIRPORTNAME &&
                user.AIRPORTNAME.toLowerCase().includes(value.toLowerCase())) ||
              (user.CITYCODE &&
                user.CITYCODE.toLowerCase().includes(value.toLowerCase())) ||
              (user.COUNTRYNAME &&
                user.COUNTRYNAME.toLowerCase().includes(value.toLowerCase())) ||
              (user.COUNTRYCODE &&
                user.COUNTRYCODE.toLowerCase().includes(value.toLowerCase())) ||
              (user.AIRPORTCODE &&
                user.AIRPORTCODE.toLowerCase().includes(value.toLowerCase())))
          );
        })
        .map((user) => {
          let priority = 3;

          if (
            user.AIRPORTCODE &&
            user.AIRPORTCODE.toLowerCase().includes(value.toLowerCase())
          ) {
            priority = 1; // Highest priority
          } else if (
            user.CITYNAME &&
            user.CITYNAME.toLowerCase().includes(value.toLowerCase())
          ) {
            priority = 2;
          } else if (
            user.COUNTRYNAME &&
            user.COUNTRYNAME.toLowerCase().includes(value.toLowerCase())
          ) {
            priority = 3;
          }

          return { ...user, priority };
        })
        .sort((a, b) => a.priority - b.priority);

      console.log("RESULTS", results);
      setCities2(results);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      // setIsLoadingFrom(false);
    }
  };

  const handleInputChange = (value) => {
    setSearchInput(value.toUpperCase());
    fetchDatas(value.toLowerCase());
    SetClickDestination(true);
    setIsItemSelected(false);
  };
  const fetchDatass = async (value) => {
    try {
      const requestData = {
        city: value,
      };

      const response = await axios.post(
        "https://admin.travelsdata.com/api/airport",
        requestData
      );

      const json = response.data;

      const results = json.data
        .filter((user) => {
          return (
            user &&
            ((user.CITYNAME &&
              user.CITYNAME.toLowerCase().includes(value.toLowerCase())) ||
              (user.AIRPORTNAME &&
                user.AIRPORTNAME.toLowerCase().includes(value.toLowerCase())) ||
              (user.CITYCODE &&
                user.CITYCODE.toLowerCase().includes(value.toLowerCase())) ||
              (user.COUNTRYNAME &&
                user.COUNTRYNAME.toLowerCase().includes(value.toLowerCase())) ||
              (user.COUNTRYCODE &&
                user.COUNTRYCODE.toLowerCase().includes(value.toLowerCase())) ||
              (user.AIRPORTCODE &&
                user.AIRPORTCODE.toLowerCase().includes(value.toLowerCase())))
          );
        })
        .map((user) => {
          let priority = 3;

          if (
            user.AIRPORTCODE &&
            user.AIRPORTCODE.toLowerCase().includes(value.toLowerCase())
          ) {
            priority = 1;
          } else if (
            user.CITYNAME &&
            user.CITYNAME.toLowerCase().includes(value.toLowerCase())
          ) {
            priority = 2;
          } else if (
            user.COUNTRYNAME &&
            user.COUNTRYNAME.toLowerCase().includes(value.toLowerCase())
          ) {
            priority = 3;
          }

          return { ...user, priority };
        })
        .sort((a, b) => a.priority - b.priority);

      setCities22(results);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleInputChange2 = (value) => {
    setSearchInput2(value.toUpperCase());
    fetchDatass(value.toLowerCase());
    SetClickDestination2(true);
    setIsItemSelected2(false);
  };

  // const [fareRules, setFareRules] = useState("");
  // const handleClickRule = async (id) => {
  //   setActiveId(activeId === id ? null : id);
  //   // const response1 = await axios.post(
  //   //   "http://admin.Innovate Blues.com/api/flightfarerule",
  //   //   {
  //   //     APIToken: tokensss || tokenss,
  //   //     BookingKey: bookingKey || bookingKeyss,
  //   //     ContractId: id,
  //   //   }
  //   // );

  //   setFareRules(response1.data.data.FareRule);
  // };

  const [openFilter, setOpenFilter] = useState(null);
  const filterRef = useRef(null);

  const toggleFilter = (name) => {
    setOpenFilter((prev) => (prev === name ? null : name));
  };
  const closeFilter = () => {
    setOpenFilter(null);
  };

  // Detect outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setOpenFilter(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSwapInputs = () => {
    const tempInput = searchInput;

    setSearchInput(searchInput2);

    setSearchInput2(tempInput);

    // Optional: Reset dropdowns or focus
    SetClickDestination(false);
    SetClickDestination2(false);
  };

  return (
    <div
      className="flightListPage roundtrippg "
      style={{ position: "relative" }}
    >
      <div className="bgGradient"></div>{" "}
      <ReSearchForm
        dataSearch={dataSearch}
        handleSubmit={handleSubmit}
        tripsActive={tripsActive}
        active={active}
        active2={active2}
        active3={active3}
        handleSearchFlight={handleSearchFlight}
        handleSearchFlightRound={handleSearchFlightRound}
        handleSearchFlightMultiPle={handleSearchFlightMultiPle}
        setTripsActive={setTripsActive}
        searchInput={searchInput}
        searchInput2={searchInput2}
        SetClickDestination={SetClickDestination}
        SetClickDestination2={SetClickDestination2}
        isItemSelected={isItemSelected}
        isItemSelected2={isItemSelected2}
        handleInputChange={handleInputChange}
        handleInputChange2={handleInputChange2}
        filteredCities={cities2}
        filteredCities2={cities22}
        clickDestination={clickDestination}
        clickDestination2={clickDestination2}
        handleCitySelect={handleCitySelect}
        handleCitySelect2={handleCitySelect2}
        startDate={startDate}
        setStartDate={setStartDate}
        moment={moment}
        endDate={endDate}
        toggleCalendar={toggleCalendar}
        rooms={rooms}
        setTravellerActive={setTravellerActive}
        travellerActive={travellerActive}
        updateRoom={updateRoom}
        selectedOption={selectedOption}
        handleOptionChange={handleOptionChange}
        calVisible={calVisible}
        setCalVisible={setCalVisible}
        handleDatesChange={handleDatesChange}
        focusedInput={focusedInput}
        setFocusedInput={setFocusedInput}
        renderDayContents={renderDayContents}
        numberOfMonths={numberOfMonths}
        appDisk="flight_list"
        handleSwapInputs={handleSwapInputs}
        onPrevMonthClick={handlePrevMonthClick}
        onNextMonthClick={handleNextMonthClick}
        dayFareMap={dayFareMap}
      />
      <div className="flightsMainBody">
        {/* <Navbar /> */}
        {/* <Bookingmenu /> */}
        <Container className="bodyDiv" style={{ position: "relative" }}>
          <Row>
            <FilterBar
              showFilter={showFilter}
              minFare={minFare}
              maxFare={maxFare}
              sliderValue={sliderValue}
              clearAllFilters={clearAllFilters}
              handleSliderChange={handleSliderChange}
              handledepTimeFilter={handledepTimeFilter}
              deptimeRange={deptimeRange}
              arrtimeRange={arrtimeRange}
              handlearrTimeFilter={handlearrTimeFilter}
              handleShowAllStops={handleShowAllStops}
              checkedStops={checkedStops}
              handleCheckedstops={handleCheckedstops}
              handleShowAllairlinenames={handleShowAllairlinenames}
              airlines={airlines}
              handleChecked={handleChecked}
              setShowFilter={setShowFilter}
              applyFilters={applyFilters}
              handleChnageCurrency={handleChnageCurrency}
              airlineCodes={airlineCodes}
            />
            <Col md={9} className="rightDiv" style={{ paddingRight: "0px" }}>
              <Row style={{ margin: "0px", padding: "0px" }} className="mbsm">
                <div className="calendarSlider" style={{ padding: "0px", border: '1px solid #eee', borderRadius: '0px', overflow: 'hidden' }}>
                  <div className="sliderLeft" style={{ width: "100%", display: 'flex', alignItems: 'center', background: '#fff' }}>
                    <button
                      className="prev-btn"
                      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '10px', display: 'flex', alignItems: 'center' }}
                    >
                      <SlArrowLeft size={18} color="#1d489f" />
                    </button>
                    <div className="swiper-container-wrapper" style={{ flexGrow: 1, overflow: 'hidden' }}>
                      <Swiper
                        modules={[Navigation]}
                        navigation={{
                          prevEl: '.prev-btn',
                          nextEl: '.next-btn',
                        }}
                        breakpoints={{
                          320: { slidesPerView: 4 },
                          480: { slidesPerView: 4 },
                          768: { slidesPerView: 5 },
                          1024: { slidesPerView: 8 },
                          1200: { slidesPerView: 8 }
                        }}
                        spaceBetween={0}
                        className="mySwiper"
                      >
                        {sliderItems.map((item, index) => {
                           const isSelected = dataSearch && dataSearch.Segments && dataSearch.Segments[0] && 
                                              moment(dataSearch.Segments[0].PreferredDepartureTime).format("YYYY-MM-DD") === item.fullDate;
                           return (
                             <SwiperSlide key={index}>
                                 <CalenderSliderContent
                                 style={{ 
                                   textWrap: "nowrap", 
                                   borderRight: '1px solid #eee', 
                                   padding: '8px 0',
                                   backgroundColor: isSelected ? '#f0f4ff' : 'transparent',
                                   borderBottom: isSelected ? '2px solid #1d489f' : 'none',
                                   cursor: 'pointer'
                                 }}
                                 className="calenderslideritem"
                                 onClick={() => handleDateClick(item.fullDate)}
                               >
                                 <p
                                   style={{
                                     display: "flex",
                                     flexDirection: "column",
                                     justifyContent: "center",
                                     paddingInline: "5px",
                                     marginBottom: "2px",
                                     fontSize: "13px",
                                     fontWeight: isSelected ? "700" : "500",
                                     color: isSelected ? "#1d489f" : "#333"
                                   }}
                                   className="calenderslidercontent"
                                 >
                                   {item.date}
                                 </p>
                                 <p
                                   style={{
                                     fontSize: "11px",
                                     color: isSelected ? "#1d489f" : "rgb(45, 50, 144)",
                                     marginBottom: "2px",
                                     fontWeight: "600",
                                   }}
                                   className="calenderprice"
                                 >
                                   {item.price !== "0" ? `₹${handleChnageCurrency(item.price)}` : "N/A"}
                                 </p>
                               </CalenderSliderContent>
                             </SwiperSlide>
                           );
                        })}
                      </Swiper>
                    </div>
                    <button
                      className="next-btn"
                      style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '10px', display: 'flex', alignItems: 'center' }}
                    >
                      <SlArrowRight size={18} color="#1d489f" />
                    </button>
                  </div>

                </div>
              </Row>
              <Row style={{ display: "none" }}>
                <div className="promotionWithoutCarousel" id="carouselBanner">
                  <div className="promotionsCard">
                    <span
                      className="bgProperties bannerImg LEFT_IMAGE_TEXT "
                      style={{
                        backgroundImage:
                          'url("https://imgak.mmtcdn.com/flights/assets/media/common/hdfc_logo.webp")',
                      }}
                    />
                    <div className="promotionContent">
                      <span className="fontSize14 blackFont blackText">
                        <b>Up to Rs. 1500 Instant Discount and No-cost EMI</b>
                      </span>
                      <span className="promotionRedline" />
                      <span className="fontSize12 blackText">
                        on HDFC Bank Credit Cards*. Use Code: HDFCEMI
                      </span>
                    </div>
                  </div>
                  <div className="promotionsCard">
                    <span
                      className="bgProperties bannerImg LEFT_IMAGE_TEXT "
                      style={{
                        backgroundImage:
                          'url("https://imgak.goibibo.com/flights-gi-assets/dt/listing/priceLockDiscBanner.webp")',
                      }}
                    />
                    <div className="promotionContent">
                      <span className="fontSize14 blackFont blackText">
                        <b>Price Lock: Pay Later</b>
                      </span>
                      <span className="promotionRedline" />
                      <span className="fontSize12 blackText">
                        Unsure about your plans? Secure prices now, pay later
                      </span>
                    </div>
                  </div>
                </div>
              </Row>
              <Row
                style={{
                  margin: "0px",
                  padding: "0px",


                  background: "#6199b82b",
                  borderRadius:'0px'
                  // borderRadius: "5px 5px 0px 0px",
                }}
                className="d-md-flex row_backgorund_list_TG"
              >
                <div className="menuItems menuItem_TG_List_head">
                  <p
                    style={{ marginLeft: "3px" }}
                    className="airlines_flight_list"
                  >
                    AIRLINES
                  </p>
                  <p className="depart_flight_list">DEPART</p>
                  <p className="duration_flight_list">DURATION</p>
                  <p className="arrive_flight_list">ARRIVE</p>
                  <p className="price_flight_list">PRICE</p>
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    className="recommend_flight_list"
                  >
                    <p>RECOMMENDED</p>
                    <label
                      className="toggleSwitch"
                      style={{
                        marginTop: "0px",
                        marginLeft: "5px",
                        marginRight: "2px",
                      }}
                    >
                      <input
                        className="toggleInput"
                        type="checkbox"
                        checked={sortType === "smart"}
                        onChange={(e) =>
                          setSortType(e.target.checked ? "smart" : null)
                        }
                      />
                      <span className="toggleSlider" />
                    </label>
                  </div>
                </div>
              </Row>
              {search && search.length !== 0 && !isLoading ? (
                <div>
                  {search &&
                    filteredData &&
                    filteredData.map((e, indexx) => {
                      return (
                        <>
                          <FlightListCard
                            key={indexx}
                            e={e}
                            handleMoreFare={handleMoreFare}
                            handleClick={handleClick}
                            activeId={activeId}
                            showModal={showModal}
                            setShowModal={setShowModal}
                            formatTime={formatTime}
                            handlebookmodal={handlebookmodal}
                            handleChnageCurrency={handleChnageCurrency}
                            fareRules={fareRules}
                            handleClickPhone={handleClickPhone}
                            activeFlightId={activeFlightId}
                            moreFare={moreFare}
                            setSelectedFare={setSelectedFare}
                            selectedFare={selectedFare}
                            setMoreFare={setMoreFare}
                            moreFareLoading={moreFareLoading}
                            dataSearch={dataSearch}
                          />
                          {indexx === 2 && (
                            <div
                              id="divLoginOfferListing1"
                              className="imglistslider_TG ng-scope"
                            >
                              {/*img src="/content/img/zero-convience-strip1.png" alt="Discount" style="width:100%"*/}
                              <a target="_blank">
                                <img
                                  src="https://cdn.gyftr.com/blog/wp-content/uploads/2024/06/14062621/Blog-banner-Cleartrip.-1.png"
                                  alt="Summer Sale"
                                />
                              </a>
                            </div>
                          )}
                        </>
                      );
                    })}
                </div>
              ) : (
                <div className="d-flex flex-column gap-3">
                  <FlightListSkeleton />
                  {/* <FlightListSkeleton />
                  <FlightListSkeleton />
                  <FlightListSkeleton /> */}
                </div>
              )}
            </Col>
          </Row>
          <div
            className={`filter_bar_flightList ${
              Visible ? "visible" : "hidden"
            }`}
          >
            <div className="menu-container">
              <div className="menu-item" onClick={() => toggleFilter("filter")}>
                <TbFilterFilled className="icon" size={22} />
                Filter
              </div>
              <div
                className="menu-item"
                onClick={() => {
                  if (checkedStops.includes("non-stop")) {
                    setCheckedStops(["1-stop"]);
                  } else {
                    setCheckedStops(["non-stop"]);
                  }
                }}
                style={{ cursor: "pointer" }}
              >
                {checkedStops.includes("non-stop") ? (
                  <BsToggleOff className="icon" size={30} />
                ) : (
                  <BsToggleOn className="icon" size={30} color="#1d489f" />
                )}
                Stops
              </div>

              {/* <div
                className="menu-item"
                onClick={() => setIsNonStop((prev) => !prev)}
                style={{ cursor: "pointer" }}
              >
                {isNonStop ? (
                  <MdToggleOn
                    className="icon"
                    size={30}
                    color="#1d489f"
                    onClick={() => handleCheckedstops("1-stop")}
                  />
                ) : (
                  <MdToggleOff
                    className="icon"
                    size={30}
                    onClick={() => handleCheckedstops("non-stop")}
                  />
                )}
                Stops
              </div> */}
              <div className="menu-item" onClick={() => toggleFilter("time")}>
                <MdOutlineAccessTimeFilled className="icon" size={22} />
                Time
              </div>
              <div
                className="menu-item"
                onClick={() => toggleFilter("airlines")}
              >
                <SiChinasouthernairlines className="icon" size={22} />
                Airline
              </div>
              <div className="menu-item" onClick={() => toggleFilter("sort")}>
                <MdOutlineSort className="icon" size={22} />
                Sort
              </div>
            </div>
          </div>
          {/* <FaFilter /> Filter */}
        </Container>
      </div>
      <div className="border p-3">
        {openFilter === "filter" && (
          <Filter
            closeFilter={closeFilter}
            showFilter={showFilter}
            minFare={minFare}
            maxFare={maxFare}
            sliderValue={sliderValue}
            clearAllFilters={clearAllFilters}
            handleSliderChange={handleSliderChange}
            handledepTimeFilter={handledepTimeFilter}
            deptimeRange={deptimeRange}
            arrtimeRange={arrtimeRange}
            handlearrTimeFilter={handlearrTimeFilter}
            handleShowAllStops={handleShowAllStops}
            checkedStops={checkedStops}
            handleCheckedstops={handleCheckedstops}
            handleShowAllairlinenames={handleShowAllairlinenames}
            airlines={airlines}
            handleChecked={handleChecked}
            setShowFilter={setShowFilter}
            applyFilters={applyFilters}
            handleChnageCurrency={handleChnageCurrency}
            airlineCodes={airlineCodes}
          />
        )}
        {openFilter === "sort" && (
          <Sort
            clearAllFilters={clearAllFilters}
            closeFilter={closeFilter}
            sortType={sortType}
            setSortType={setSortType}
          />
        )}

        {openFilter === "time" && (
          <Time
            closeFilter={closeFilter}
            showFilter={showFilter}
            minFare={minFare}
            maxFare={maxFare}
            sliderValue={sliderValue}
            clearAllFilters={clearAllFilters}
            handleSliderChange={handleSliderChange}
            handledepTimeFilter={handledepTimeFilter}
            deptimeRange={deptimeRange}
            arrtimeRange={arrtimeRange}
            handlearrTimeFilter={handlearrTimeFilter}
            handleShowAllStops={handleShowAllStops}
            checkedStops={checkedStops}
            handleCheckedstops={handleCheckedstops}
            handleShowAllairlinenames={handleShowAllairlinenames}
            airlines={airlines}
            handleChecked={handleChecked}
            setShowFilter={setShowFilter}
            applyFilters={applyFilters}
            handleChnageCurrency={handleChnageCurrency}
            airlineCodes={airlineCodes}
          />
        )}
        {openFilter === "airlines" && (
          <Airlines
            closeFilter={closeFilter}
            showFilter={showFilter}
            minFare={minFare}
            maxFare={maxFare}
            sliderValue={sliderValue}
            clearAllFilters={clearAllFilters}
            handleSliderChange={handleSliderChange}
            handledepTimeFilter={handledepTimeFilter}
            deptimeRange={deptimeRange}
            arrtimeRange={arrtimeRange}
            handlearrTimeFilter={handlearrTimeFilter}
            handleShowAllStops={handleShowAllStops}
            checkedStops={checkedStops}
            handleCheckedstops={handleCheckedstops}
            handleShowAllairlinenames={handleShowAllairlinenames}
            airlines={airlines}
            handleChecked={handleChecked}
            setShowFilter={setShowFilter}
            applyFilters={applyFilters}
            handleChnageCurrency={handleChnageCurrency}
            airlineCodes={airlineCodes}
          />
        )}
      </div>
    </div>
  );
};
